module.exports = __webpack_public_path__ + "static/img/6_western_eastern_japan.6bedfc2f.png";